<div class="card-wrapper">
    <div class="card">
        <div class="card-header">
            <app-heading [text]="title()" [level]="'h3'"></app-heading>
            <app-ui-button-text [label]="buttonLabel()" [size]="'small'" [leftIcon]="buttonIcon()" (clicked)="handleClick()"></app-ui-button-text>
        </div>

        <div class="card-chart">
            <app-ui-grid [uiGridOptions]="gridOptions()"></app-ui-grid>
        </div>

    </div>

</div>
